import { render, staticRenderFns } from "./WebNoResult.vue?vue&type=template&id=1698c80e&"
import script from "./WebNoResult.vue?vue&type=script&lang=js&"
export * from "./WebNoResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports